import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StatistikService } from '../../statistik.service';
import { BehaviorSubject, combineLatest, Observable, Subject } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';
import { AuthSelectors, SessionSelectors } from '@store';
import { StatistikDaekning } from '../../models/StatistikDaekning';

@Component({
    selector: 'app-statistik-daekning',
    template: `
        <app-statistik-daekning-ui
            [laCards]="laCards$ | async"
            [kaCards]="kaCards$ | async"
            [saCards]="saCards$ | async"
            [daekning]="daekning$ | async"
            [periode]="periode$ | async"
            [user]="user$ | async"
            (periodeChange)="periodeChange($event)"
            (saChange)="saChange($event)"
            (reload)="reload()"
        ></app-statistik-daekning-ui>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikDaekningContainer {
    reloadSubject = new BehaviorSubject<void>(null);
    reload$ = this.reloadSubject.asObservable();
    periodeSubject = new Subject<{fra: string, til: string}>();
    periode$ = this.periodeSubject.asObservable();
    saSubject = new BehaviorSubject<number>(0);
    sa$ = this.saSubject.asObservable();
    daekning$: Observable<StatistikDaekning[]> = combineLatest([
        this.statistikService.visible$,
        this.statistikService.step$,
        this.periode$,
        this.sa$,
        this.reload$
    ]).pipe(
        filter(([visible, step]) => visible && step === 5),
        switchMap(([, , periode, sa]) => this.statistikService.getDaekning(periode, sa))
    );
    laCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersLA$(new Date(date.fra))));
    kaCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersKA$(new Date(date.fra))));
    saCards$ = this.periode$.pipe(switchMap(date => this.sessionSelector.usersSA$(new Date(date.fra))));
    user$ = this.authSelector.user$;

    constructor(
        private statistikService: StatistikService,
        private sessionSelector: SessionSelectors,
        private authSelector: AuthSelectors,
    ) { }

    reload() {
        this.reloadSubject.next();
    }

    periodeChange(periode: {fra: string; til: string}) {
        this.periodeSubject.next(periode);
    }

    saChange(sa: number) {
        this.saSubject.next(sa);
    }
}

